import { jsx as _jsx } from "react/jsx-runtime";
import { useAppSelector, useAppDispatch } from '../hooks';
import { runMacro } from '../actions/RunMacro';
export const MacroButton = (props) => {
    const dispatch = useAppDispatch();
    const macros = useAppSelector(state => state.definitions.macros.entities);
    const macro = macros[props.id];
    if (macro == undefined) {
        return null;
    }
    return (_jsx("button", { className: "lw-button macro", onClick: () => dispatch(runMacro(macro.id)), children: macro.title }, props.id));
};
